

import React from 'react';
import styles from './JobseekerProfileEmployerViewBody.module.css';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import i18next from 'i18next';
import { useGetSkillsHook } from '../../../../utils/utilityHooks';

function Skills({ jobseeker, ref }) {
    const { t } = useTranslation();
     const skills = useGetSkillsHook();
    const currentLanguage = i18next.language;

    return (
        <div ref={ref} id="skills" className={styles.overViewContainer} style={{ backgroundColor: 'transparent' ,padding:'0px',}}>
            <h2 className={`${styles.heading} ${styles.removeMarginBottom}`}>{t('job_seeker.general_skills')}</h2>
            <div className={styles.skillListContainer}>
                {jobseeker?.skills.map((item, index) => {
                    const progressPercentage = (item?.skillLevel / 6) * 100; // Calculate progress percentage
                    let skillName = item?.code;
                    if (skills && skills.length > 0) {
                        const skillData = skills.find(s => s.id === item.code);
                        if (skillData) {
                            skillName = currentLanguage === "en" ? skillData.labelen : skillData.labelar;
                        }
                    }
                    return (
                        <div className={styles.block} key={index}>
                            <div className={styles.blockBody}>
                                <p className={styles.description} style={{ textAlign: "left" }}>{skillName}</p>
                                <div className={styles.progressBarContainer}>
                                    <div
                                        className={styles.progressBar}
                                        style={{
                                            width: `${progressPercentage}%`,
                                            backgroundColor: "#0464B2",
                                        }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );
}

export default Skills;
